import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

//
import ImageBox from "../../general/ImageBox";

//
import { iconImage } from "../../../redux/features/coins/actions";

function MobileTopWinners({ items }) {
  return (
    <div className="box-type">
      {items.map((item) => (
        <div className="items" key={item.id}>
          <header>
            <div className="img-name-price">
              <ImageBox src={iconImage(item.symbol.split("/")[0])} />
              <div>
                <p className="text-black fw-bolder">{item.symbol}</p>
                <small>
                  {item.base_name} <i className="las la-sync-alt"></i>{" "}
                  {item.target_name}
                </small>
              </div>
            </div>

            <Link to={`coin-detail/${item.symbol.split("/")[0]}`}>
              <i className="las la-angle-right"></i>
            </Link>
          </header>
          <div className="content zebra">
            <div className="item">
              <small className="mb-0">Enter Price</small>
              <small className="text-dark">
                {Number(item.entry_price).toFixed(
                  item.base_name === "Bitcoin" ? 2 : 8
                ).replace(/\.?0+$/, "")}
              </small>
            </div>

            <div className="item">
              <small className="mb-0">Action</small>
              <small
                className={`fw-bolder  ${
                  item.action == "BUY" ? "text-success" : "text-danger"
                }`}
              >
                {item.action}
              </small>
            </div>

            <div className="item">
              <small className="mb-0">Win Status</small>
              <small className="text-dark fw-bolder">{item.status}</small>
            </div>

            <div className="item">
              <small className="mb-0">Max Profit(%)</small>
              <small className="text-dark fw-bolder">
                {item.max_profit_amount}%
              </small>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

MobileTopWinners.propTypes = {
  selectedCoin: PropTypes.object.isRequired,
};

export default MobileTopWinners;
